import PropTypes from "prop-types";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoader } from "@/hooks/LoaderProvider";
import { deletePollSurvey } from "@/store/redux/slices/polls_&_survey/polls_&_survey";
import Delete from "@/components/common/alerts/Delete";
import Button from "@/components/common/Button";

const ActionButtons = ({ poll, onDeleteSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useLoader();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleModifyClick = () => {
    navigate(`/dashboard/polls/edit/${poll._id}`);
  };

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setShowDeleteModal(false);
      showLoader();
      await dispatch(deletePollSurvey(poll._id)).unwrap();
      hideLoader();
      onDeleteSuccess();
    } catch (error) {
      console.error("Failed to delete poll/survey:", error);
      hideLoader();
    }
  };

  return (
    <>
      <div className="flex gap-4">
        <Button
          text="DELETE"
          onClick={handleDeleteClick}
          customBgColor="white"
          customTextColor="primary"
          className="h-[34px] flex-1 border border-primary hover:bg-white"
        />
        <Button
          text="MODIFY"
          onClick={handleModifyClick}
          className="h-[34px] flex-1"
          customBgColor="primary"
          customTextColor="white"
          isActive={true}
          color="primary"
        />
      </div>

      {/* Delete Modal */}
      <Delete
        isVisible={showDeleteModal}
        onProceed={handleConfirmDelete}
        header="Delete Poll/Survey"
        paragraph="Are you sure you want to delete this poll/survey? This action cannot be undone."
        proceedButtonText="Delete"
        cancelButtonText="Cancel"
        onClose={() => setShowDeleteModal(false)}
      />
    </>
  );
};

ActionButtons.propTypes = {
  poll: PropTypes.shape({
    _id: PropTypes.string,
  }),
  onDeleteSuccess: PropTypes.func,
};

export default ActionButtons;
